module.exports = __webpack_public_path__ + "static/media/logo_black.e25ae7b6df.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/equestrian/logo_black.png
// module id = 6425
// module chunks = 0